import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AEB3B1E9-D2B4-497C-9939-BFB549F57019
 * name comment-bookmark
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-bookmark.svg
 * tags
 */
export const CommentBookmarkIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M19 13L16.5 11.5L14 13V5H19V13Z" /></>, 'CommentBookmarkIcon');
export default CommentBookmarkIcon